import axios from 'axios'
import form_settings_dev from '../../static/form_settings'
import router from '../router'

function getCookie (key) {
  var res = document.cookie.match(key + '=(.*?)($|;)')
  if (res) {
    return res[1]
  }
  return undefined
}

function setCookie (key, value, expires) {
  document.cookie = key + '=' + value + ';max-age=' + expires
}

const DEV = process.env.NODE_ENV === 'development'
let END_POINT
if (!DEV) {
  END_POINT =
    'https://agree-form.takakuureru.com/prod'
} else {
  END_POINT = 'https://agree-form.takakuureru.com/dev'
}

export default {
  /**
   * accessTokenの発行
   */
  createAccessToken (cb) {
    const AUTH_API = 'https://jz1b3ftv3i.execute-api.ap-northeast-1.amazonaws.com/prod/authorize'
    const APP_ID = '5c3eda5fb4668d00016771f9'

    // Cookieに存在する場合はCookieを使用する
    let tmpAt = getCookie('access_token')
    if (tmpAt && tmpAt !== 'undefined') {
      cb({ access_token: tmpAt })
    } else {
      let apiUrl = AUTH_API
      let params = {
        application_id: APP_ID,
        scope: 'delivery_auto_agree_api:UI'
      }
      axios
        .post(apiUrl, params, {
          headers: {
            'Content-Type': 'application/json',
            'X-Current-Application-Id': APP_ID
          }
        })
        .then(res => {
          // console.log(res)
          if (res.data.access_token) {
            // 有効期限1日 延長更新なし
            setCookie('access_token', res.data.access_token, 86400)
            cb(res.data)
          } else {
            reject(res.statusText)
          }
        })
        .catch(error => {
          // console.log('---- AccessToken発行失敗 ----')
          // console.log(error)
          gtag('event', 'access_token error', {
            event_label: 'createAccessToken:' + error,
            event_category: 'connect',
            non_interaction: true
          })
          cb(error)
        })
    }
  },
  getInfo (accessToken, cb) {
    const ACCESS_PATH = '/forms/'
    let urlParam = router.history.current.query.code
    let apiUrl = END_POINT + ACCESS_PATH + urlParam
    let headers
    if (!DEV) {
      headers = {
        'Content-Type': 'application/json',
        'X-Access-Token': accessToken
      }
    } else {
      headers = {
        'Content-Type': 'application/json'
      }
    }
    axios({
      method: 'GET',
      url: apiUrl,
      headers
    })
      .then(r => {
        let res = {}
        if (r.data.error) {
          if (r.data.error.message === 'submitted') {
            res = 'submitted'
          } else if (r.data.error.message === 'expired') {
            res = 'expired'
          } else if (r.data.error.message === 'non-existent form') {
            res = 'nonexistent'
          }
        } else {
          res = r.data.item
        }
        cb(res)
      })
      .catch(error => {
        let res = {}
        res = 'nonexistent'
        gtag('event', 'getInfo error', {
          event_label: 'getInfo:' + error,
          event_category: 'connect',
          non_interaction: true
        })
        cb(res, error)
      })
  },
  saveInfo (type, cb) {
    const ACCESS_PATH = '/forms/answers'
    let urlParam = router.history.current.query.code
    let apiUrl = END_POINT + ACCESS_PATH

    let params = {
      'url_code': router.history.current.query.code,
      'answer': type
    }
    let headers
    if (!DEV) {
      headers = {
        headers: {
          'Content-Type': 'application/json',
          'X-Access-Token': getCookie('access_token')
        }
      }
    } else {
      headers = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    }
    axios
      .post(apiUrl, params, headers)
      .then(res => {
        cb(res)
      })
      .catch(error => {
        // console.log('---- saveInfo error ----')
        // console.log(error)
        gtag('event', 'saveInfo error', {
          event_label: 'saveInfo:' + error,
          event_category: 'connect',
          non_interaction: true
        })
        cb('error')
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js